import { I18nOptions, LocaleMessages, createI18n } from "vue-i18n";
import dateTimeFormats from "./util/i18n/datetime-formats";
import getBrowserLocale from "./util/i18n/get-browser-locale";
import numberFormats from "./util/i18n/number-formats";
import { supportedLocalesInclude } from "./util/i18n/supported-locales";

function loadLocaleMessages(): Record<string, LocaleMessages<string>> {
  const locales = require.context("./locales", true, /[A-Za-z0-9-_,\s]+\.json$/i);
  const messages: Record<string, LocaleMessages<string>> = {};
  locales.keys().forEach((key) => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale: string = matched[1];
      messages[locale] = locales(key);
    }
  });
  return messages;
}

function getStartingLocale() {
  const browserLocale = getBrowserLocale();
  if (supportedLocalesInclude(browserLocale ?? "")) {
    return browserLocale;
  } else {
    return process.env.VUE_APP_I18N_LOCALE || "en";
  }
}

const options: I18nOptions = {
  legacy: false,
  globalInjection: true,
  locale: getStartingLocale(),
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || "en",
  messages: loadLocaleMessages(),
  missingWarn: false,
  fallbackWarn: false,
  warnHtmlMessage: false,
  silentTranslationWarn: true,
  datetimeFormats: dateTimeFormats,
  numberFormats: numberFormats
};

const i18n = createI18n(options);

export default i18n;
